import { Box, Button, Grid, Paper, Chip, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { EmployeeList, Filter } from "./Index";
import { StencilList } from "react-placemoulder";
import { styled } from "@mui/material/styles";
import { axiosFetch } from "../../../utils/AxiosFetch";
import InfiniteScroll from "react-infinite-scroller";
import dummyData from "./contentLoaderData.json";
import AddUserModal from "../../../shared/AddUserModal";
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from "react-redux";
import "./Employee.css";
import { load_UserDetails } from '../../../redux/actions/user.actions';
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";
import * as XLSX from 'xlsx';
import { useSearchParams } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  height: 80,
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderColor: "black",
}));

function EmployeeDirectory(props) {
  const navigate = useNavigate();
  const [userlist, setUserList] = useState(dummyData);
  const [dummy, setDummy] = useState(dummyData);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [isActive, setIsActive] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [title, setTitle] = useState("");
  const [department, setDepartment] = useState("");
  const [location, setLocation] = useState("");
  const [reportingManager, setReportingManager] = useState(null);
  const [alphabet, setAlphabet] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [isPopupOpen, setisPopupOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [searchParam, setSearchParam] = useSearchParams();
  const [isDownloadable, setIsDownloadable] = useState(true);

  const [downloadData, setDownloadData] = useState([]);

  const [resultPerPg, setResultPerPg] = useState(7);
  const dispatch = useDispatch();
  let employeeList = useSelector(state => state.employeeList.employees);
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

  const [alphabets, setalphabets] = useState([
    "All",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ]);
  const [selectAlpha, setSelectAlpha] = useState(null)
  useEffect(() => {
    window.scrollTo(0, 0);
    var req = {
      Keyword: keyword,
      Alphabet: alphabet,
      DepartmentName: department,
      JobTitle: title,
      Location: location,
      ReportingManagerId: reportingManager,
      IsActive: isActive,
      Page: pageNo,
      ResultsPerPage: resultPerPg,
    };
    // dispatch(load_UserDetails(req))
    fetchProfileList(req);
  }, []);
  useEffect(() => {
    if (employeeList.length !== 0) {
      if (employeeList.pagination !== undefined) {
        setPagination(employeeList.pagination);
        setPageNo(employeeList.pagination.page);
      }
      if (employeeList !== undefined) {
        setUserList(employeeList);
      }
      setLoading(false);
    }
  }, [employeeList])

  const fetchProfileList = (req) => {
    axiosFetch({
      method: "POST",
      url: "/employees/search",
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {

          setSearchParam(req)

          if (res.data.profiles.length > 0) {
            setIsDownloadable(true)
          }
          else {
            setIsDownloadable(false)
          }
          // if (res.data.pagination === null && res.data.profiles.length !== 0) {
          //   setDownloadData(res.data.profiles);
          //   const result = res.data.profiles.map(({
          //     createdDate,
          //     createdby,
          //     createdbyNavigation,
          //     department,
          //     departmentCode,
          //     departmentId,
          //     departmentImage,
          //     description,
          //     employeeCode,
          //     employeeLevel,
          //     employeeLevelId,
          //     employeeTypeId,
          //     id,
          //     isActive,
          //     isManager,
          //     jobTitleId,
          //     lastAppraiselDate,
          //     linkedIn,
          //     location,
          //     modifiedDate,
          //     modifiedby,
          //     modifiedbyNavigation,
          //     notifyUser,
          //     officeLocationId,
          //     originalPhotoName,
          //     parent,
          //     password,
          //     personalEmailId,
          //     profilePhotoName,
          //     reportingManger,
          //     reportingMangerId,
          //     reportingPersonDepartmentName,
          //     reportingPersonEmailId,
          //     reportingPersonEmpCode,
          //     reportingPersonId,
          //     reportingPersonJobTitle,
          //     reportingPersonTeam,
          //     team,
          //     teamCount,
          //     teamId,
          //     user,
          //     userId,
          //     userType,
          //     userTypeId,
          //     yearOfExperience,
          //     zoomId, ...rest
          //   }) => {
          //     console.log(rest);
          //     return rest;

          //   });
          //   let header = ["Empolyee Number", "Employee First Name", "Employee Last Name", "Email Address", "Designation", "Department Name", "Team Name", "Reporting Manager First Name", "Reporting Manager Last Name"]
          //   // let header = ["Current CTC", "Email Address", "Employee Number", "First Name", "Designation", "Joinging Date", "Last Name", "Office Location", "Contact Number", "Reporting Manager First Name", "Reporting Manager Last Name", "Other Email Address", "Team Name"]
          //   var wb = XLSX.utils.book_new(),
          //     ws = XLSX.utils.sheet_add_json(ws, result, { origin: 'A2', skipHeader: true });
          //   XLSX.utils.sheet_add_aoa(ws, [header]);
          //   XLSX.utils.book_append_sheet(wb, ws, "DownloadData");
          //   XLSX.writeFileXLSX(wb, "EmployeeDetails.xlsx");

          // }
          if (req.Page > 1) {
            var user = [...userlist.profiles, ...res.data.profiles];
            setUserList({ profiles: user });
            setPagination(res.data.pagination);
            setPageNo(res.data.pagination.page);
            setScrolling(false);
          }
          else {
            setUserList(res.data);
            setPagination(res.data.pagination);
            setPageNo(res.data.pagination.page);
          }
          setLoading(false);
        }
        if (res.status === 400) {
          setLoading(false);
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleActive = (value) => {
    setAlphabet(null)
    window.scrollTo(0, 0);
    if (isActive) {
      setIsActive(false);
    } else {
      setIsActive(true);
    }
    var req = {
      Keyword: keyword,
      Alphabet: null,
      DepartmentName: department,
      JobTitle: title,
      Location: location,
      ReportingManagerId: reportingManager,
      IsActive: value,
      Page: 1,
      ResultsPerPage: resultPerPg,
    };
    setLoading(true);
    fetchProfileList(req);
  };
  const handleKeyword = (value) => {
    setKeyword(value);
  };
  const handleTitleSearch = (value) => {
    setTitle(value);
  };
  const onSearch = (req) => {
    window.scrollTo(0, 0);
    setLoading(true);
    fetchProfileList(req);
  };
  const onReset = (req) => {
    setAlphabet(null)
    setSelectAlpha(null)
    fetchProfileList(req);
  };
  const onAlphabetSearch = (alphaValue) => {
    setAlphabet(alphaValue)
    var req = {
      Keyword: keyword,
      Alphabet: alphaValue,
      DepartmentName: department,
      JobTitle: title,
      Location: location,
      ReportingManagerId: reportingManager,
      IsActive: isActive,
      Page: 1,
      ResultsPerPage: resultPerPg,
    };
    window.scrollTo(0, 0);
    setLoading(true);
    fetchProfileList(req);
  };
  const handleDepartment = (value) => {
    setDepartment(value);
  };
  const handleLocation = (value) => {
    setLocation(value);
  };
  const handleReportingManager = (value) => {
    setReportingManager(value);
  };
  const handlePagination = (event, value) => {
    if (pageNo + 1 <= pagination.totalPages) {
      setPageNo(pageNo + 1);
      var req = {
        Keyword: keyword,
        Alphabet: alphabet,
        DepartmentName: department,
        JobTitle: title,
        Location: location,
        ReportingManagerId: reportingManager,
        IsActive: isActive,
        Page: pageNo + 1,
        ResultsPerPage: resultPerPg,
      };
      fetchProfileList(req)
      setScrolling(true);
    }
  };
  // const fetchProfileListWithPagination = (req) => {
  //   axiosFetch({
  //     method: "POST",
  //     url: "/employees/search",
  //     requestConfig: req,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         console.log(res.data);
  //         var user = [...userlist.profiles, ...res.data.profiles];
  //         console.log([...userlist.profiles, ...res.data.profiles]);
  //         setPagination(res.data.pagination);
  //         setPageNo(res.data.pagination.page);
  //         setUserList({ profiles: user });
  //         setScrolling(false);
  //       }
  //       if (res.status === 401) {
  //         navigate("/");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const handlePopup = () => {
    console.log("clicked");
    if (isPopupOpen) {
      setisPopupOpen(false);
    } else {
      setisPopupOpen(true);
    }
  };
  const handleAlphaSearch = (alpha) => {
    setAlphabet(alpha === "All" ? null : alpha)
    setSelectAlpha(alpha === "All" ? null : alpha)
    onAlphabetSearch(alpha === "All" ? null : alpha)
  }

  return (
    <div className="argus-user-list">
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <h1 className="main-heading">Employee List</h1>
            {isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR" ?
              <Button variant="contained" className="theme-btn m-top" onClick={() => handlePopup()}>Add People</Button> : ""}
          </Grid>
          <Grid item xs={12} className="alphabet-sec">
            <Stack spacing={3} className="d-block-class">
              {alphabets.map((alpha) => {
                return (
                  <Chip
                    size="small"
                    key={alpha}
                    className="alphabet-search"
                    label={alpha}
                    color={alpha === selectAlpha ? "secondary" : "primary"}
                    value={alpha}
                    onClick={() => {
                      handleAlphaSearch(alpha)
                    }
                    }
                  />
                );
              })}
            </Stack>
          </Grid>
          <Grid item xs={3} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Filter
              showInactive={handleActive}
              searchTitle={handleTitleSearch}
              searchKeyword={handleKeyword}
              selectDepartment={handleDepartment}
              selectLoation={handleLocation}
              selectManager={handleReportingManager}
              filterUser={onSearch}
              reset={onReset}
              // onAlphaSearch={onAlphabetSearch}
              alphabet={alphabet}
              isData={isDownloadable}
            />
          </Grid>
          <Grid item xs={12} md={9} lg={9} xl={9}>
            {loading ? (
              <StencilList
                length={1}
                Component={EmployeeList}
                data={userlist}
              />
            ) : (
              <InfiniteScroll
                dataLength={userlist.profiles.length}
                initialLoad={false}
                loadMore={scrolling === false ? handlePagination : ''}
                // loader={<div className="loader" key={0}>Loading ...</div>}
                hasMore={pageNo <= pagination.totalPages}
                threshold={500}
              >
                <EmployeeList {...userlist} activeUsers={isActive} onAlphaSearch={onAlphabetSearch} />
              </InfiniteScroll>
            )}
            {scrolling ? (
              <StencilList length={1} Component={EmployeeList} data={dummy} />
            ) : (
              ""
            )}
          </Grid>
          {/* <Grid item xs={12} alignItems="right" display="flex" justifyContent="right">
                        {pagination.totalPages !== 0?<Pagination count={pagination.totalPages} page={pageNo} onChange={handlePagination}/>:""}
                    </Grid> */}
        </Grid>
      </Box >
      <AddUserModal openModal={isPopupOpen} addUser={handlePopup} />
    </div >
  );
}
export default EmployeeDirectory;
